export const bankDetailConstants = {
  GET_SINGLE_REQUEST: "BANK_DETAIL_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "BANK_DETAIL_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "BANK_DETAIL_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "BANK_DETAIL_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "BANK_DETAIL_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "BANK_DETAIL_GET_ALL_FAILURE",

  ADD_REQUEST: "BANK_DETAIL_ADD_REQUEST",
  ADD_SUCCESS: "BANK_DETAIL_ADD_SUCCESS",
  ADD_FAILURE: "BANK_DETAIL_ADD_FAILURE",

  UPDATE_REQUEST: "BANK_DETAIL_UPDATE_REQUEST",
  UPDATE_SUCCESS: "BANK_DETAIL_UPDATE_SUCCESS",
  UPDATE_FAILURE: "BANK_DETAIL_UPDATE_FAILURE",

  DELETE_REQUEST: "BANK_DETAIL_DELETE_REQUEST",
  DELETE_SUCCESS: "BANK_DETAIL_DELETE_SUCCESS",
  DELETE_FAILURE: "BANK_DETAIL_DELETE_FAILURE",

  CLEAR: "BANK_DETAIL_CLEAR",
};
